// returns the lineHeight as a number of pixels.
export const calculateLineHeight = (textarea: HTMLTextAreaElement): number => {
  const computedStyle = window.getComputedStyle(textarea);
  const computedlineHeight = computedStyle.lineHeight;
  if (computedlineHeight === 'normal') {
    // We get 'normal' for values 'initial', 'inherit', 'unset' and 'normal'
    // TODO: Unclear if we need this.
    // getComputedStyle always return fontSize in pixels.  Not likely a float, but since it's legal
    // we use parseFloat()
    const fontSize = parseFloat(computedStyle.fontSize);
    return 1.2 * fontSize;
  }
  return parseFloat(computedlineHeight);
};
export const getStylingHeight = (textarea: HTMLTextAreaElement) => {
  const cssStyle = window.getComputedStyle(textarea);
  const paddingTop = parseFloat(cssStyle.paddingTop);
  const paddingBottom = parseFloat(cssStyle.paddingBottom);
  const borderTop = parseFloat(cssStyle.borderTop);
  const borderBottom = parseFloat(cssStyle.borderBottom);
  return { paddingHeight: paddingTop + paddingBottom, borderHeight: borderTop + borderBottom };
};
